// 自定义业务错误
export class BusinessError extends Error {
  code?: number;
  data?: any;
  constructor(message: string, code?: number, data?: any) {
    super(message);
    this.name = "BusinessError";
    this.code = code; // 业务错误码
    this.data = data; // 业务错误数据
  }
}

// 自定义网络错误
export class NetworkError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "NetworkError";
  }
}
